import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-up",
  "use": "chevron-up-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"chevron-up\">\n<path d=\"M0 336l48 48 208-208 208 208 48-48-255.999-256-256.001 256z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol